/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Cli_CaptionInputs */

const en_hub_cli_caption = /** @type {(inputs: Hub_Cli_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imports never touch your PRD quota — 20 per day per account.`)
};

const id_hub_cli_caption = /** @type {(inputs: Hub_Cli_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impor tidak memotong kuota PRD — 20 per hari per akun.`)
};

/**
* | output |
* | --- |
* | "Imports never touch your PRD quota — 20 per day per account." |
*
* @param {Hub_Cli_CaptionInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_cli_caption = /** @type {((inputs?: Hub_Cli_CaptionInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Cli_CaptionInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_cli_caption(inputs)
	return en_hub_cli_caption(inputs)
});